import { find, assign, compact } from 'lodash-es';

export default function transformOptions(options, variants) {

  return options.map(option => {
    return assign( {}, option, {
      values: compact(
        option.values.map(value => {
          const criteria = {}
          criteria['option' + option.position] = value;
          const variantForCriteria = find(variants, criteria);
          if (!variantForCriteria) { return; }
          return {
            label: value,
            available: !!variantForCriteria.available
          };
        })
      )
    });
  });
}